import { getServerMediaUrl } from "./mediaUrl";

const DESCRIPTION_FALLBACK =
  "Добро пожаловать! Нажмите кнопку ниже, чтобы начать программу.";

export const SERVICE_LOGO_SRC = `${process.env.PUBLIC_URL}/images/brand/inchat-logo.svg`;

export function buildStartPostPreview(game) {
  if (!game) return null;

  const title = game.title?.trim() || "Название программы";
  const description =
    game.description?.trim() || DESCRIPTION_FALLBACK;
  const posterSrc = game.poster
    ? getServerMediaUrl(game.poster, game.updatedAt ?? "")
    : SERVICE_LOGO_SRC;

  return {
    title,
    description,
    posterSrc,
    isExample: Boolean(game.isExample),
  };
}

const PREVIEW_START_POST_KEY_PREFIX = "InChat:preview-start-post:";

export function wasStartPostShownInPreview(gameId) {
  if (!gameId) return true;
  return Boolean(localStorage.getItem(`${PREVIEW_START_POST_KEY_PREFIX}${gameId}`));
}

export function markStartPostShownInPreview(gameId) {
  if (!gameId) return;
  localStorage.setItem(`${PREVIEW_START_POST_KEY_PREFIX}${gameId}`, "1");
}
